import { post } from '../Services/http';
import { toggleLoader } from './GenericGridView.action';
import { catchError } from './Error.action';

export const ORDER_SCANNING_RECEIVE = 'ORDER_SCANNING_RECEIVE';

export const addToCart = (rows, url) => (dispatch, getState) => {
    dispatch(toggleLoader(true));

    return post('/api/orderscanning', rows)
        .then((response) => response.json())
        .then(response => receive(response))
        .then(data => {
            if (data != null) {
                location.href = url;
            }
            dispatch(toggleLoader(false));
        })
        .catch((ex) =>
            dispatch(catchError(ex, error => loadError(error)))
        );
}

export const receive = (response) => {
    return {
        type: ORDER_SCANNING_RECEIVE,
        payload: { response },
    };
};
